import { FC } from "react";
import { Grid } from "@mui/material";

import { PageHeader } from "@dzambalaorg/mui-page-layout";
import {
  ClaimSection,
  DiscreteSection,
  DispenserSection,
  Erc1155Section,
  Erc20Section,
  Erc721Section,
  Erc998Section,
  MarketplaceSection,
  NativeSection,
  StakingSection,
  WaitListSection,
  ServiceType,
} from "@framework/shared";

import { Root } from "./styled";
import { AchievementsSection } from "./mechanics/achievements";
// import { EcommerceSection } from "./ecommerce";
// import { ChainLinkSection } from "./integrations/chain-link";
// import { CoinGeckoSection } from "./integrations/coin-gecko";
// import { CoinMarketCapSection } from "./integrations/coin-market-cap";
// import { AssetPromoSection } from "./mechanics/promo";
// import { BreedSection } from "./mechanics/breed";
import { CollectionSection } from "./mechanics/collection";
// import { LootSection } from "./mechanics/loot";
// import { LotterySection } from "./mechanics/lottery";
// import { MysterySection } from "./mechanics/mystery";
// import { RaffleSection } from "./mechanics/raffle";
// import { RentSection } from "./mechanics/rent";
// import { PonziSection } from "./mechanics/ponzi";
// import { PaymentSplitterSection } from "./mechanics/payment-splitter";
// import { PredictionSection } from "./mechanics/prediction";
import { RecipesSection } from "./mechanics/recipes";
// import { ReferralSection } from "./mechanics/referral";
import { SettingsSection } from "./mechanics/settings";

export const Dashboard: FC = () => {
  return (
    <Root>
      <PageHeader message="pages.dashboard.title" />

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <NativeSection service={ServiceType.ADMIN} />
          <Erc20Section />
          <Erc721Section />
          <Erc998Section />
          <Erc1155Section />
          {/*TODO - open after random will be able in waterfall*/}
          {/*<MysterySection />*/}
          {/*<LootSection />*/}
          <CollectionSection />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <DispenserSection />
          <WaitListSection />
          <ClaimSection />
          <DiscreteSection />
          <RecipesSection />
          {/*<AssetPromoSection />*/}
          {/*<RentSection />*/}
          {/*<BreedSection />*/}
          {/*<RaffleSection />*/}
          {/*<LotterySection />*/}
          <StakingSection />
          {/*<PonziSection />*/}
          {/*<PredictionSection />*/}
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          {/*<ReferralSection />*/}
          {/*<ChainLinkSection />*/}
          {/*<CoinGeckoSection />*/}
          {/*<CoinMarketCapSection />*/}
          <MarketplaceSection service={ServiceType.ADMIN} />
          {/*<EcommerceSection />*/}
          <AchievementsSection />
          <SettingsSection />
          {/*<PaymentSplitterSection />*/}
        </Grid>
      </Grid>
    </Root>
  );
};
